import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { setCurrentTab } from '../../../redux/slices/presentationsSliceBO';
import {
    useLazyGetAllPresentacionesQuery,
    useLazyGetRGRLPresentacionesBOQuery,
    useLazyGetRARPresentacionesBOQuery,
    useLazyGetSVCCPresentacionesBOQuery
} from '../../../services/presentacionesApi';
import { useEffect } from 'react';

const usePresentationsBOTableTabs = ({
    filters,
    extraFilters,
    clearFilters,
    clearAllSelected
}: {
    filters: any;
    extraFilters: any;
    clearFilters: () => void;
    clearAllSelected: () => void;
}) => {
    const dispatch = useDispatch();
    const currentTabIndex = useAppSelector((state) => state.presentationsBO.currentTab);

    const ENDPOINTS_BY_TAB = [
        useLazyGetRGRLPresentacionesBOQuery,
        useLazyGetRARPresentacionesBOQuery,
        useLazyGetSVCCPresentacionesBOQuery
    ];

    const [getData, result] =
        typeof ENDPOINTS_BY_TAB[currentTabIndex] === 'function'
            ? ENDPOINTS_BY_TAB[currentTabIndex]()
            : [() => Promise.resolve(null), { isLoading: false, error: 'Invalid tab function' }];

    useEffect(() => {
        const fetch = async () => {
            try {
                //makethe default value of extraFilters is {} in case of null
                if (!extraFilters) {
                    extraFilters = {};
                }

                let mergedFilters = {
                    ...filters,
                    ...extraFilters
                };

                await getData(mergedFilters);
            } catch (error) {
                console.error('Error fetching data for tab:', error);
            }
        };
        fetch();
    }, [currentTabIndex, filters, extraFilters]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        dispatch(setCurrentTab(newValue));
        clearFilters();
        clearAllSelected();
    };

    return {
        currentTabIndex,
        getData,
        result,
        isFetching: result?.isFetching || false,
        handleTabChange
    };
};

export default usePresentationsBOTableTabs;
